import BarChart from './src/js/barChart'
import HorizontalBarChart from './src/js/horizontalBarChart'
import CheckConnection from './src/js/checkConnection'
import ProcessedTile from './src/js/processedTile'
import MotivatePlayer from './src/js/lib/motivatePlayer'
import TableWithPadding from './src/js/tableWithPadding'
import TitleBlock from './src/js/titleBlock'
import ImgBlock from './src/js/imgBlock'
import Clock from './src/js/clock'
import LogoWithClockHorizontal from './src/js/logoWithClockHorizontal'
import Countdown from './src/js/countDown'
import ActiveCardWithCounter from './src/js/activeCardWithCounter'
import CardWithCounterTable from './src/js/cardWithCounterTable'

export default {
    BarChart,
    HorizontalBarChart,
    CheckConnection,
    ProcessedTile,
    TableWithPadding,
    TitleBlock,
    ImgBlock,
    Clock,
    LogoWithClockHorizontal,
    Countdown,
    ActiveCardWithCounter,
    CardWithCounterTable,




    MotivatePlayer
}